export const VERTICAL_NAME = 'MINIAPP_PAYMENTS';
